import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StatusLdPage } from './status-ld.page';

const routes: Routes = [
  {
    path: '',
    component: StatusLdPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatusLdPageRoutingModule {}
